exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{display:relative}#sidebar{position:fixed;top:51.8px;right:0;bottom:0;width:18%;background-color:#f5f5f5;padding:0}#sidebar .ui.menu{margin:2em 0 0;font-size:16px}#sidebar .ui.menu>a.item{color:#337ab7;border-radius:0!important}#sidebar .ui.menu>a.item.active{background-color:#337ab7;color:#fff;border:none!important}#sidebar .ui.menu>a.item:hover{background-color:#4f93ce;color:#fff}#content{margin-left:20px;margin-right:19%;width:81%;margin-top:3em;padding-left:3em;float:left}#content>.ui.grid{padding-right:4em;padding-bottom:3em}#content h1{font-size:36px}#content .ui.divider:not(.hidden){margin:0}#content table.ui.table{border:none}#content table.ui.table thead th{border-bottom:2px solid #eee!important}.ui.segment{border:0;-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f390210","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navigation.vue
// module id = PmQn
// module chunks = 1